import { render, staticRenderFns } from "./DocumentKenmerk.vue?vue&type=template&id=005b5501"
import script from "./DocumentKenmerk.vue?vue&type=script&lang=js"
export * from "./DocumentKenmerk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports